import { render, staticRenderFns } from "./TodoDeliveryOrderPurchaseRequest.vue?vue&type=template&id=6d96ec91&scoped=true&"
import script from "./TodoDeliveryOrderPurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./TodoDeliveryOrderPurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./TodoDeliveryOrderPurchaseRequest.vue?vue&type=style&index=0&id=6d96ec91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96ec91",
  null
  
)

export default component.exports